import pick from "lodash/pick";
export default function getUtmsAndAdditionalData(
  query,
  hasAdditionalData = true
) {
  let dadosAdicionais = pick(
    query,
    Object.keys(query).filter(item => !item.includes("utm"))
  );
  // todos os valores em dadosAdicionais devem ser strings
  dadosAdicionais = Object.keys(dadosAdicionais).reduce((acc, item) => {
    acc[item] = String(dadosAdicionais[item]);
    return acc;
  }, {});
  const utm = pick(
    query,
    Object.keys(query).filter(item => item.includes("utm"))
  );
  dadosAdicionais.ddd = dadosAdicionais.ddd.toString();
  if (hasAdditionalData) utm.dadosAdicionais = dadosAdicionais;

  return utm;
}
